import React, { useEffect } from "react";
import { ModalBottom, ModalTop } from "../../assets/Icon/ModalIcon";
import { useMediaQuery, useTheme } from "@mui/material";

type InvoiceDrawerProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  width?: number; // percentage of screen (default 33)
};

const InvoiceDrawer: React.FC<InvoiceDrawerProps> = ({
  open,
  onClose,
  children,
  width = 40,
}) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("lg"));
  // ESC key close
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    if (open) document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  // Prevent background scroll
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        justifyContent: "flex-end",
        background: open ? "rgba(0,0,0,0.35)" : "transparent",
        pointerEvents: open ? "auto" : "none",
        transition: "background 0.2s ease",
      }}
    >
      {/* Drawer */}
      <div
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
        style={{
          width: isTablet ? "90%" : `${width}vw`,
          height: "100vh",
          background: "#fff",
          boxShadow: "-8px 0 25px rgba(0,0,0,0.15)",
          borderTopLeftRadius: 12,
          borderBottomLeftRadius: 12,
          padding: 25,
          overflowY: "auto",
          transform: open ? "translateX(0)" : "translateX(100%)",
          transition: "transform 0.25s ease",
        }}
      >
        <div
          style={{
            position: "fixed",
            right: 0,
            top: 0,
          }}
        >
          <ModalTop />
        </div>
        {/* <div
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
          }}
        >
          <ModalBottom />
        </div> */}
        {children}
      </div>
    </div>
  );
};

export default InvoiceDrawer;
